import { FormattedMessage } from 'react-intl'

import GridList from 'app/components/base/GridList'
import Text from 'app/components/base/Text'

import UploadImageItem from '../components/UploadImageItem'
import UploadReportInput from '../components/UploadReportInput'
import UploadField, { UploadFieldProps } from '../UploadField'

export type UploadReportImageProps = Omit<UploadFieldProps, 'renderInput'>

const UploadReportImageField: RFC<UploadReportImageProps> = (rest) => {
  return (
    <UploadField
      accept={{ image: ['image/*'] }}
      renderInput={UploadFieldInput}
      renderComponent={(props) => (
        <UploadFieldComponent disabled={props.disabeld} {...props} />
      )}
      multiple
      {...rest}
    />
  )
}

const UploadFieldInput = ({ getRootProps, getInputProps }) => {
  return (
    <UploadReportInput
      {...getRootProps()}
      sx={{ mb: 2 }}
      inputProps={{ ...(getInputProps() as any) }}
    >
      <Text component="span" variant="body1" sx={{ color: 'text.primary' }}>
        <FormattedMessage defaultMessage="Attach your image(s)" />
      </Text>
    </UploadReportInput>
  )
}

const UploadFieldComponent = ({ value, onDelete, disabled }) => {
  return (
    <GridList
      items={value}
      columns={3}
      spacing={2}
      renderItem={(item) => (
        <UploadImageItem
          key={item.id}
          {...item}
          onDelete={onDelete}
          disabled={disabled}
        />
      )}
    />
  )
}

export default UploadReportImageField
